class SupportedLanguages {

    initialized = false;
    languages = [];
    defaultLanguageData = {
        label: 'Deutsch',
        value: 'de',
        translationKey: 'german',
        thousandsSeparator: ',',
        decimalSeparator: '.',
        formats: {
            fullDate: 'DD.MM.YYYY',
            monthYear: 'MM.YYYY',
            fullTime: 'HH:mm:ss',
            hourMinute: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm',
        },
        contact: {
            name: 'ZSK Stickmaschinen GmbH (Deutschland)',
            tel: '+49 (0) 2151 444-0',
            email: 'zsk@zsk.de'
        }
    };

    constructor() {

        this.loadLanguages();

        if (this.languages.length > 0) this.initialized = true;

    }

    getLanguages() {

        if (!this.initialized) return [];

        const languages = [];

        this.languages.forEach(
            (languageData) => {
                languages.push(this.fillDefaultLanguageData(languageData));
            }
        );

        return languages;

    }

    getLanguageCodes() {

        if (!this.initialized) return [];

        return this.languages.map((language) => { return language.value; });

    }

    getLanguageOptions() {

        if (!this.initialized) return [];

        return this.languages.map((language) => { return {'value': language.value, 'label': language.label} });

    }

    getLanguageCodeOptions() {

        if (!this.initialized) return [];

        return this.languages.map((language) => { return {'value': language.value, 'label': language.value} });

    }

    getLanguageTranslateOptions() {

        if (!this.initialized) return [];

        return this.languages.map((language) => {
            return {
                value: language.value,
                label: language.label + ' (' + language.value + ')',
                title: language.label
            }
        });

    }

    getLanguageData(language) {

        if (!this.initialized) return null;

        let languageData = this.findLanguage(language);

        if (languageData !== undefined) languageData = this.fillDefaultLanguageData(languageData);

        return (languageData !== null) ? languageData : null;

    }

    getFormatByLanguage(language) {

        if (!this.initialized) return null;

        const languageData = this.findLanguage(language);

        return (languageData !== null) ? languageData.formats : this.defaultLanguageData.formats;

    }

    getContactByLanguage(language) {

        if (!this.initialized) return null;

        let languageData = this.findLanguage(language);

        if (languageData === null) languageData = this.findLanguage('de');

        return (languageData !== null) ? languageData.contact : this.defaultLanguageData.contact;

    }

    findLanguage(language = 'en') {

        if (!this.initialized || !language) return null;

        const languageData = this.languages.find((lang) => { return (lang.value === language); });

        return (languageData !== undefined) ? this.fillDefaultLanguageData(languageData) : null;

    }

    fillDefaultLanguageData(languageData) {

        if (!this.initialized || !languageData) return null;

        const filledData = {};

        for (let index in this.defaultLanguageData) {
            let value = this.defaultLanguageData[index];

            filledData[index] = (languageData[index]) ? languageData[index] : value;
        }

        return filledData;

    }

    loadLanguages() {

        this.languages = [
            {
                label: 'Deutsch',
                value: 'de',
                translationKey: 'german',
                thousandsSeparator: '.',
                decimalSeparator: ',',
                formats: {
                    fullDate: 'DD.MM.YYYY',
                    monthYear: 'MM.YYYY',
                    fullTime: 'HH:mm:ss',
                    hourMinute: 'HH:mm',
                    datetime: 'DD.MM.YYYY HH:mm',
                },
                contact: {
                    name: 'ZSK Stickmaschinen GmbH (Deutschland)',
                    tel: '+49 (0) 2151 444-0',
                    email: 'zsk@zsk.de'
                }
            },
            {
                label: 'English',
                value: 'en',
                translationKey: 'english',
                thousandsSeparator: ',',
                decimalSeparator: '.',
                formats: {
                    fullDate: 'MM/DD/YYYY',
                    monthYear: 'MM/YYYY',
                    fullTime: 'HH:mm:ss',
                    hourMinute: 'HH:mm',
                    datetime: 'MM/DD/YYYY HH:mm',
                },
                contact: {
                    name: 'ZSK USA Inc.',
                    tel: '+1 717-706-7702',
                    email: 'topher@zsk.de'
                }
            },
            /*{
                label: 'Español',
                value: 'es',
                translationKey: 'spanish'
            },*/
            /*{
                label: 'Français',
                value: 'fr',
                translationKey: 'french'
            },*/
            {
                label: 'Italiano',
                value: 'it',
                translationKey: 'italian'
            },
            /*{
                label: 'Polski',
                value: 'pl',
                translationKey: 'polish'
            },*/
            /*{
                label: 'Português',
                value: 'pt',
                translationKey: 'portuguese'
            },*/
            /*{
                label: 'Russisch',
                value: 'ru',
                translationKey: 'russian'
            },*/
            /*{
                label: 'Türk',
                value: 'tr',
                translationKey: 'turkish'
            }*/
        ];

    }

}

export default SupportedLanguages;